<template>
  <div class="tag-extension">
    <div class="ext-header">
      <div>Selected</div>
      <div class="selected-number">{{ additionalTags.length }} Preferences</div>
    </div>
    <div class="selected-tags">
      <Tag
        :tag="tag"
        v-for="tag in additionalTags"
        :key="tag.id"
        @click="toggleTag(tag)"
        :darkSelection="true"
        class="tag-withcheckmark"
      />
    </div>
  </div>
</template>

<script>
import Tag from '@common/filter-tag/tag.vue';

export default {
  components: {
    Tag,
  },
  props: {
    additionalTags: Array,
  },
  methods: {
    toggleTag(tag) {
      this.$emit('toggle-tag', tag);
    },
  },
};
</script>

<style scoped>
.ext-header {
  text-align: left;
  color: var(--font-color-dark);
  font-weight: bold;
  font-size: 14px;
  border: none;
  background-color: transparent;
  border-radius: 0;
  border-right: 1px solid #f1f1f1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.selected-number {
  padding-right: 10px;
  position: relative;
  color: var(--font-color-light);
  font-size: 12px;
  font-weight: normal;
  white-space: nowrap;
}

.tag-extension {
  position: absolute;
  max-width: 400px;
  background: #ffffff;
  box-shadow: 0px 0px 33px rgba(0, 0, 0, 0.13);
  border-radius: 10px;
  text-align: left;
  z-index: 10000;
  padding: 17px 13px 13px;
  transition: opacity 0.3s ease-in-out;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  pointer-events: none;
  opacity: 0;
  white-space: normal;
  display: flex;
}

.tag-extension:before {
  content: '';
  position: absolute;
  width: 100%;
  height: 80px;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 50%);
}

.tag-extension.active {
  opacity: 1;
}

.tag-withcheckmark {
  padding: 8px 10px 6px;
  font-weight: 500;
  font-size: 12px;
  line-height: 118.14%;
  /* or 14px */

  letter-spacing: -0.005em;

  color: #333;
}

.tag-withcheckmark::before {
  content: '';
  position: absolute;
  top: 2px;
  right: 3px;
  margin: -8px -8px 0 0;
  opacity: 1;
  transform: none;
  width: 12px;
  height: 12px;
  border-radius: 14px;
  background-color: #a3abb6;
  border: 2px solid #fff;
  background-image: url("data:image/svg+xml,%3Csvg width='6' height='5' viewBox='0 0 6 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.3215 0.617066C5.53299 0.794617 5.56051 1.11 5.38296 1.3215L2.86444 4.3215C2.76944 4.43466 2.62925 4.50001 2.48149 4.50001C2.33374 4.50001 2.19355 4.43466 2.09855 4.3215L0.617066 2.55679C0.439515 2.3453 0.467031 2.02991 0.678526 1.85236C0.890021 1.67481 1.20541 1.70233 1.38296 1.91382L2.48149 3.22237L4.61707 0.678526C4.79462 0.467031 5.11 0.439515 5.3215 0.617066Z' fill='white'/%3E%3C/svg%3E%0A");
  background-size: 7px;
  background-position: 1px 1px;
  background-repeat: no-repeat;
}

.selected-tags {
  max-width: 300px;
  overflow: auto;
  white-space: nowrap;
}
</style>
